import { render, staticRenderFns } from "./GridButton.vue?vue&type=template&id=98233aba&scoped=true&"
import script from "./GridButton.vue?vue&type=script&lang=js&"
export * from "./GridButton.vue?vue&type=script&lang=js&"
import style0 from "./GridButton.vue?vue&type=style&index=0&id=98233aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98233aba",
  null
  
)

export default component.exports